var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProffesionalismNetImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 444,
    height: 212,
    viewBox: "0 0 444 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M444 80.6179L442.211 79.9699L444 80.1619V79.5139L436.857 78.7339L444 81.3139V80.6179Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M444 128.415L423.364 118.419L444 102.111V101.271L422.14 118.551L444 129.147V128.415Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M444 101.271L423.568 117.423L439.714 79.766L444 81.314V80.618L439.654 79.046L439.354 78.938L421.948 119.535L444 102.111V101.271Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.48
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M333.642 41.0529L334.362 82.2258L328.636 77.4377L329.056 76.9337L333.69 80.8098L333.054 44.821L328.312 74.9537L327.664 74.8457L332.994 41.0049L333.642 41.0529Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M329.465 75.0619C329.333 75.866 328.576 76.418 327.772 76.298C326.968 76.166 326.416 75.4099 326.536 74.6059C326.668 73.8019 327.424 73.2499 328.228 73.3699C329.033 73.4899 329.585 74.2579 329.465 75.0619Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.32
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M329.849 76.106C329.225 75.578 328.288 75.662 327.76 76.286C327.232 76.91 327.316 77.846 327.94 78.362C328.564 78.89 329.501 78.806 330.029 78.182C330.557 77.558 330.473 76.622 329.849 76.094V76.106Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.38
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M306.272 0L333.786 13.0803L334.062 12.4803L307.796 0H306.272Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.38
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M334.182 0L334.795 12.0003L335.443 11.9643L334.843 0H334.182Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.02
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M336.595 11.8323C336.631 12.6483 336.007 13.3443 335.191 13.3803C334.374 13.4163 333.678 12.7923 333.642 11.9763C333.606 11.1603 334.23 10.4642 335.047 10.4282C335.863 10.3922 336.559 11.0163 336.595 11.8323Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.42
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M333.222 14.0882C333.954 14.4362 334.843 14.1242 335.191 13.3922C335.539 12.6601 335.227 11.7721 334.495 11.4241C333.762 11.0761 332.874 11.3881 332.526 12.1201C332.178 12.8521 332.49 13.7402 333.222 14.0882Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M444 129.147V128.415L422.896 118.191L422.572 118.023L407.95 160.36L408.563 160.576L422.944 118.935L444 129.147Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M444 144.303L408.923 160.888L409.211 161.488L444 145.035V144.303Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.7
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M409.763 162.496C409.031 162.844 408.142 162.532 407.794 161.788C407.446 161.056 407.758 160.168 408.502 159.82C409.235 159.472 410.123 159.784 410.471 160.528C410.819 161.26 410.507 162.148 409.763 162.496Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.09
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M406.882 159.916C406.618 160.684 407.026 161.524 407.794 161.8C408.563 162.064 409.403 161.656 409.679 160.888C409.943 160.12 409.535 159.28 408.767 159.004C407.998 158.74 407.158 159.148 406.882 159.916Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.4
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M416.57 39.1089L439.942 79.4058L439.762 79.5858L392.356 126.555L414.913 39.3369L415.549 39.5049L393.593 124.407L439.126 79.2978L416.005 39.4449L416.57 39.1089Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.64
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M413.785 39.1209C413.989 38.3288 414.793 37.8608 415.585 38.0648C416.378 38.2688 416.846 39.0729 416.642 39.8649C416.438 40.6569 415.633 41.1249 414.841 40.9209C414.049 40.7169 413.58 39.9129 413.785 39.1209Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.06
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M417.602 38.6049C417.194 37.8969 416.282 37.6569 415.585 38.0649C414.877 38.4729 414.637 39.3849 415.045 40.081C415.453 40.789 416.366 41.029 417.062 40.621C417.77 40.213 418.01 39.3009 417.602 38.6049Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.29
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M415.549 39.505L393.173 126.027L333.414 81.47L414.193 38.437L414.493 39.013L334.639 81.566L392.777 124.923L414.913 39.337L415.549 39.505Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.57
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M413.58 37.4526C414.301 37.0686 415.201 37.3446 415.585 38.0646C415.969 38.7846 415.693 39.6847 414.973 40.0687C414.253 40.4527 413.352 40.1767 412.968 39.4567C412.584 38.7366 412.86 37.8366 413.58 37.4526Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.06
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M416.642 39.8646C416.846 39.0726 416.366 38.2686 415.585 38.0646C414.793 37.8606 413.989 38.3406 413.785 39.1206C413.58 39.9006 414.061 40.7166 414.841 40.9206C415.633 41.1246 416.438 40.6446 416.642 39.8646Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.11
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M393.965 125.571L338.84 139.371L336.871 101.474L337.532 101.438L339.464 138.543L391.984 125.391L338.276 100.946L338.54 100.346L393.965 125.571Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.39
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M337.868 102.014C337.124 101.678 336.799 100.802 337.136 100.058C337.472 99.3144 338.348 98.9904 339.092 99.3264C339.837 99.6624 340.161 100.538 339.825 101.282C339.488 102.026 338.612 102.35 337.868 102.014Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.16
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M338.684 101.462C338.636 100.646 337.952 100.022 337.136 100.058C336.319 100.094 335.695 100.79 335.731 101.606C335.767 102.422 336.463 103.046 337.28 103.01C338.096 102.962 338.72 102.278 338.684 101.462Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.36
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M395.622 127.047L338.276 100.946L338.54 100.346L390.328 123.915L334.483 82.274L337.22 98.6183L336.571 98.7263L333.57 80.7739L395.622 127.047Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.53
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M337.868 102.014C337.124 101.678 336.799 100.802 337.136 100.058C337.472 99.3144 338.348 98.9904 339.092 99.3264C339.837 99.6624 340.161 100.538 339.825 101.282C339.488 102.026 338.612 102.35 337.868 102.014Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.34
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M335.431 98.8465C335.563 99.6505 336.331 100.19 337.136 100.058C337.94 99.9265 338.48 99.1585 338.348 98.3544C338.216 97.5504 337.448 97.0104 336.643 97.1424C335.839 97.2744 335.299 98.0424 335.431 98.8465Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M278.637 0L283.919 28.1647L284.568 28.0447L279.298 0H278.637Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M306.272 0L334.302 13.3203L285.744 28.7407L285.936 29.3767L336.079 13.4523L307.796 0H306.272Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.65
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M286.356 30.4447C285.576 30.6967 284.748 30.2647 284.496 29.4847C284.244 28.7046 284.676 27.8766 285.456 27.6246C286.236 27.3726 287.065 27.8046 287.317 28.5846C287.569 29.3647 287.137 30.1927 286.356 30.4447Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.13
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M282.779 28.3086C282.935 29.1126 283.703 29.6406 284.508 29.4846C285.312 29.3286 285.84 28.5606 285.684 27.7566C285.528 26.9526 284.76 26.4245 283.955 26.5805C283.151 26.7365 282.623 27.5046 282.779 28.3086Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.26
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M278.638 0L284.016 28.6447L274.832 20.9765L274.412 21.4805L284.988 30.3247L279.298 0H278.638Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.26
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M274.772 0L273.331 18.9004L273.98 18.9484L275.432 0H274.772Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.6
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M275.132 18.9721C275.072 19.7881 274.364 20.4002 273.547 20.3282C272.731 20.2681 272.119 19.5601 272.191 18.7441C272.263 17.9281 272.959 17.3161 273.776 17.3881C274.592 17.4481 275.204 18.1561 275.132 18.9721Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.67
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M275.636 20.1362C275.012 19.6082 274.076 19.6922 273.548 20.3162C273.019 20.9403 273.103 21.8763 273.728 22.3923C274.352 22.9083 275.288 22.8363 275.816 22.2123C276.345 21.5883 276.261 20.6523 275.636 20.1242V20.1362Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M335.671 12.8882L329.909 33.0367L285.876 29.9046L285.924 29.3046L285.744 28.7406L335.683 12.8882H335.671ZM329.429 32.3526L334.711 13.8842L286.236 29.2806L329.441 32.3526H329.429Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.28
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M285.876 31.0689C285.06 31.0089 284.448 30.3009 284.508 29.4849C284.568 28.6689 285.276 28.0569 286.092 28.1169C286.909 28.1769 287.521 28.8849 287.461 29.7009C287.401 30.5169 286.693 31.1289 285.876 31.0689Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.68
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M285.456 27.6246C284.676 27.8766 284.244 28.7046 284.496 29.4847C284.748 30.2647 285.576 30.6967 286.356 30.4447C287.137 30.1927 287.569 29.3647 287.317 28.5846C287.065 27.8046 286.236 27.3726 285.456 27.6246Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M251.027 0H249.694L246.957 1.54804L247.282 2.12405L251.027 0Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M261.615 0L256.249 5.56813L247.33 2.65206L247.125 3.27608L256.429 6.31215L262.527 0H261.615Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.14
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M247.918 3.08404C247.21 3.49205 246.309 3.24005 245.901 2.53203C245.493 1.82401 245.745 0.923992 246.453 0.515983C247.162 0.107973 248.062 0.359979 248.47 1.068C248.878 1.77601 248.626 2.67603 247.918 3.08404Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.63
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M247.762 1.58431C246.982 1.33231 246.153 1.75231 245.901 2.53233C245.649 3.31235 246.069 4.14037 246.85 4.39238C247.63 4.64438 248.458 4.22437 248.71 3.44435C248.962 2.66434 248.542 1.83632 247.762 1.58431Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.06
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M249.695 0L247.018 1.51204L248.098 0H247.294L246.441 1.20003L246.969 1.56004L247.282 2.12405L251.027 0H249.695Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.63
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M247.918 3.08404C247.21 3.49205 246.309 3.24005 245.901 2.53203C245.493 1.82401 245.745 0.923992 246.453 0.515983C247.162 0.107973 248.062 0.359979 248.47 1.068C248.878 1.77601 248.626 2.67603 247.918 3.08404Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.13
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M238.29 0L244.472 2.34005L244.701 1.72804L240.139 0H238.29Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.17
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M243.992 3.38429C244.761 3.6723 245.613 3.28829 245.901 2.52027C246.189 1.75225 245.805 0.900231 245.037 0.612224C244.268 0.324218 243.416 0.708227 243.128 1.47624C242.84 2.24426 243.224 3.09628 243.992 3.38429Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.43
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M269.154 0H268.41L263.512 9.66023L272.371 19.5005L272.851 19.0684L264.304 9.55222L269.154 0Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.43
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M274.772 0L273.331 18.9004L273.98 18.9484L275.432 0H274.772Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.47
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M275.132 18.9721C275.072 19.7881 274.364 20.4002 273.547 20.3282C272.731 20.2681 272.119 19.5601 272.191 18.7441C272.263 17.9281 272.959 17.3161 273.776 17.3881C274.592 17.4481 275.204 18.1561 275.132 18.9721Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.05
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M271.459 20.2206C271.999 20.8326 272.935 20.8806 273.548 20.3286C274.16 19.7766 274.208 18.8525 273.656 18.2405C273.115 17.6285 272.179 17.5805 271.567 18.1325C270.955 18.6845 270.906 19.6085 271.459 20.2206Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.06
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M268.41 0L264.244 8.20819L264.832 8.5082L269.154 0H268.41Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.06
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M262.527 0H261.615L255.793 6.03614L262.503 9.28822L262.779 8.7002L256.885 5.84414L262.527 0Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.39
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M265.889 8.96408C265.516 9.6961 264.628 9.9841 263.896 9.61209C263.164 9.24009 262.875 8.35206 263.248 7.62005C263.62 6.88803 264.508 6.60002 265.24 6.97203C265.973 7.34404 266.261 8.23206 265.889 8.96408Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.69
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M261.927 10.2964C262.659 10.6564 263.548 10.3444 263.908 9.61236C264.268 8.88035 263.956 7.99233 263.224 7.63232C262.491 7.27231 261.603 7.58432 261.243 8.31633C260.883 9.04835 261.195 9.93637 261.927 10.2964Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.23
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M392.897 125.163L393.101 125.775L344.218 147.064L343.954 146.464L389.211 126.759L339.609 139.179L342.538 145.9L341.937 146.164L338.696 138.735L339.068 138.639L392.897 125.163Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.32
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M344.746 148.083C344.002 148.407 343.126 148.071 342.802 147.315C342.478 146.571 342.814 145.695 343.57 145.371C344.314 145.047 345.191 145.383 345.515 146.139C345.839 146.883 345.503 147.759 344.746 148.083Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.11
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M340.845 146.56C341.169 147.304 342.045 147.652 342.79 147.328C343.534 147.004 343.882 146.128 343.558 145.384C343.234 144.639 342.358 144.291 341.613 144.615C340.869 144.939 340.521 145.816 340.845 146.56Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.24
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M334.23 80.7617L337.22 98.6181L336.571 98.7261L333.822 82.2737L327.916 89.3299L336.439 98.7981L335.947 99.2302L327.052 89.3419L334.23 80.7617Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M338.348 98.3544C338.48 99.1585 337.94 99.9265 337.136 100.058C336.331 100.19 335.563 99.6505 335.431 98.8465C335.299 98.0424 335.839 97.2744 336.643 97.1424C337.448 97.0104 338.216 97.5504 338.348 98.3544Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M335.047 99.9505C335.587 100.563 336.523 100.611 337.136 100.059C337.748 99.5185 337.796 98.5825 337.244 97.9705C336.703 97.3585 335.767 97.3105 335.155 97.8625C334.543 98.4025 334.495 99.3385 335.047 99.9505Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.12
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M334.495 81.4822L328.636 88.4784L328.132 88.0583L333.57 81.5662L328.084 76.9821L327.844 87.9383L327.196 87.9263L327.46 75.6021L334.495 81.4822Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.58
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M329.573 89.1503C329.044 89.7743 328.12 89.8583 327.496 89.3303C326.872 88.8023 326.788 87.8782 327.316 87.2542C327.844 86.6302 328.768 86.5462 329.393 87.0742C330.017 87.6022 330.101 88.5263 329.573 89.1503Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.32
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M326.043 87.8298C326.031 88.6459 326.668 89.3179 327.484 89.3419C328.3 89.3659 328.973 88.7179 328.997 87.9018C329.009 87.0858 328.372 86.4138 327.556 86.3898C326.74 86.3658 326.067 87.0138 326.043 87.8298Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.48
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M414.709 36.9126L414.289 37.4166L395.262 21.5042L335.863 80.1736L414.193 38.4366L414.493 39.0126L332.202 82.8617L395.226 20.6162L414.709 36.9126Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.32
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M413.58 37.4526C414.301 37.0686 415.201 37.3446 415.585 38.0646C415.969 38.7846 415.693 39.6847 414.973 40.0687C414.253 40.4527 413.352 40.1767 412.968 39.4567C412.584 38.7366 412.86 37.8366 413.58 37.4526Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.22
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M413.497 38.2446C414.121 38.7726 415.057 38.6886 415.585 38.0646C416.113 37.4406 416.029 36.5046 415.405 35.9766C414.781 35.4486 413.845 35.5326 413.316 36.1566C412.788 36.7806 412.872 37.7166 413.497 38.2446Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.28
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M396.45 20.3286L335.263 80.762L334.795 80.306L394.037 21.7926L333.642 41.2931L334.326 80.114L333.678 80.126L332.982 40.8131L333.21 40.7411L396.45 20.3286Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M335.479 80.0176C335.491 80.8336 334.843 81.5057 334.026 81.5177C333.21 81.5297 332.538 80.8816 332.526 80.0656C332.514 79.2496 333.162 78.5776 333.978 78.5656C334.795 78.5536 335.467 79.2016 335.479 80.0176Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.57
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M334.038 79.43C333.462 80.006 333.45 80.942 334.026 81.518C334.603 82.094 335.539 82.106 336.115 81.53C336.691 80.954 336.703 80.018 336.127 79.442C335.551 78.8659 334.615 78.854 334.038 79.43Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.15
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M444 79.5138L440.435 79.1178L444 76.5858V75.7817L438.646 79.5858L444 80.1618V79.5138Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.43
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M444 75.7817L439.642 78.8777L416.294 38.6288L444 47.497V46.801L415.681 37.7528L414.865 37.4888L439.258 79.5138L439.438 79.8258L444 76.5857V75.7817Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.65
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M444 210.773L417.098 177.316L444 178.744V178.084L415.669 176.584L444 211.817V210.773Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M328.108 76.0459L327.844 87.9381L327.196 87.9261L327.436 76.5259L313.847 72.4458L326.836 88.0461L326.332 88.4662L311.95 71.1978L328.108 76.0459Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.28
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M328.997 87.8901C328.985 88.7061 328.3 89.3542 327.484 89.3302C326.668 89.3062 326.02 88.6341 326.044 87.8181C326.056 87.0021 326.74 86.3541 327.556 86.3781C328.373 86.4021 329.021 87.0741 328.997 87.8901Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.07
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M325.407 89.1501C325.935 89.7742 326.86 89.8581 327.484 89.3421C328.108 88.8141 328.192 87.8901 327.676 87.2661C327.148 86.6421 326.223 86.5581 325.599 87.0741C324.975 87.6021 324.891 88.5261 325.407 89.1501Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M333.87 39.6245L328.036 76.7054L314.147 72.5413L314.327 71.9173L327.508 75.8654L332.754 42.4806L313.943 70.8372L313.391 70.4772L333.87 39.6245Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.6
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M313.883 73.6697C313.102 73.4297 312.658 72.6136 312.886 71.8336C313.126 71.0536 313.943 70.6096 314.723 70.8376C315.503 71.0776 315.948 71.8936 315.719 72.6737C315.479 73.4537 314.663 73.8977 313.883 73.6697Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.48
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M329.669 31.8726L333.69 41.0888L333.594 41.2328L313.943 70.8375L313.559 70.5855L313.138 70.4055L329.669 31.8726ZM332.946 41.0288L329.681 33.5286L314.627 68.6414L332.958 41.0288H332.946Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.1
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M314.939 71.4138C314.483 72.0979 313.571 72.2779 312.886 71.8338C312.202 71.3778 312.022 70.4658 312.466 69.7818C312.922 69.0978 313.835 68.9178 314.519 69.3618C315.203 69.8058 315.383 70.7298 314.939 71.4138Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.22
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M312.118 69.8777C311.794 70.6337 312.142 71.4978 312.898 71.8218C313.655 72.1458 314.519 71.7978 314.843 71.0418C315.167 70.2857 314.819 69.4217 314.063 69.0977C313.318 68.7737 312.442 69.1217 312.118 69.8777Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.04
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M330.161 32.4009L313.751 70.6578L313.15 70.4058L329.189 32.9889L285.144 29.8568L312.382 70.4778L311.842 70.8378L283.859 29.1128L330.161 32.4009Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.24
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M314.831 71.0538C314.507 71.8098 313.643 72.1458 312.886 71.8338C312.142 71.5098 311.794 70.6458 312.106 69.8897C312.418 69.1337 313.295 68.7977 314.051 69.1097C314.807 69.4337 315.143 70.2978 314.831 71.0538Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.08
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M310.846 71.4139C311.302 72.0979 312.214 72.2779 312.898 71.8219C313.583 71.3659 313.763 70.4538 313.307 69.7698C312.85 69.0978 311.938 68.9058 311.254 69.3618C310.582 69.8178 310.389 70.7299 310.846 71.4139Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.54
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M407.65 122.522L408.13 162.159L394.541 160.671L394.601 160.023L407.458 161.427L407.026 125.871L393.989 159.015L393.389 158.775L407.65 122.522Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.69
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M395.094 159.364C394.793 160.12 393.941 160.492 393.173 160.204C392.416 159.904 392.044 159.052 392.332 158.284C392.633 157.528 393.485 157.156 394.253 157.444C395.009 157.744 395.382 158.596 395.094 159.364Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.21
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M394.805 158.896C393.989 158.812 393.269 159.4 393.173 160.204C393.089 161.02 393.677 161.74 394.481 161.836C395.298 161.92 396.018 161.332 396.114 160.528C396.21 159.724 395.61 158.992 394.805 158.896Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.19
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M423.292 117.939L408.563 160.576L408.022 160.384H407.446L407.002 123.975L407.218 123.891L423.28 117.927L423.292 117.939ZM408.106 159.916L422.224 119.043L407.674 124.443L408.106 159.928V159.916Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.64
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M409.679 160.875C409.415 161.644 408.575 162.052 407.794 161.788C407.026 161.524 406.618 160.683 406.882 159.903C407.146 159.135 407.986 158.727 408.767 158.991C409.535 159.255 409.943 160.095 409.679 160.875Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.02
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M406.294 160.336C406.294 161.152 406.978 161.8 407.794 161.8C408.611 161.8 409.259 161.116 409.259 160.3C409.259 159.484 408.575 158.836 407.758 158.836C406.942 158.836 406.294 159.52 406.294 160.336Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.64
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M407.842 123.831L394.001 159.016L393.449 158.8H392.848L392.656 125.187L407.854 123.831H407.842ZM393.497 158.5L406.846 124.575L393.305 125.787L393.497 158.512V158.5Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.26
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M392.344 158.284C392.044 159.04 392.416 159.904 393.185 160.204C393.941 160.504 394.805 160.132 395.105 159.364C395.406 158.608 395.033 157.744 394.265 157.444C393.509 157.144 392.645 157.516 392.344 158.284Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M441.023 76.7178L423.616 117.315L423.004 117.063L438.058 81.9859L408.226 123.519L421.323 118.659L421.551 119.271L406.45 124.875L441.023 76.7178Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.37
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M421.888 120.387C422.656 120.099 423.04 119.247 422.764 118.491C422.488 117.735 421.624 117.339 420.867 117.615C420.099 117.903 419.715 118.755 419.991 119.511C420.279 120.279 421.131 120.663 421.888 120.387Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.69
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M438.982 80.6778L407.518 124.503L392.092 125.883L392.741 125.247L438.31 80.1138L438.622 80.4258L438.982 80.6898V80.6778ZM407.158 123.879L436.989 82.3338L393.845 125.067L407.158 123.879Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.42
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M437.445 79.3456C438.022 78.7696 438.958 78.7696 439.534 79.3456C440.111 79.9216 440.111 80.8576 439.534 81.4336C438.958 82.0096 438.022 82.0096 437.445 81.4336C436.869 80.8576 436.869 79.9216 437.445 79.3456Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.37
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M439.871 81.4102C440.351 80.7502 440.195 79.8262 439.535 79.3461C438.874 78.8661 437.95 79.0221 437.47 79.6822C436.99 80.3422 437.146 81.2662 437.806 81.7462C438.466 82.2262 439.39 82.0702 439.871 81.4102Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.6
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M444 147.435V146.667L412.2 166.264L412.548 166.816L444 147.435Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.6
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M444 177.292L412.62 167.392L412.428 168.016L444 177.988V177.292Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.41
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M412.14 169.132C411.36 168.892 410.927 168.052 411.18 167.272C411.42 166.492 412.26 166.06 413.04 166.312C413.821 166.552 414.253 167.392 414.001 168.172C413.761 168.952 412.92 169.384 412.14 169.132Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.15
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M411.66 165.244C410.963 165.676 410.747 166.588 411.18 167.272C411.612 167.956 412.524 168.184 413.208 167.752C413.905 167.32 414.121 166.408 413.689 165.724C413.256 165.028 412.344 164.812 411.66 165.244Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.18
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M444 177.292L412.62 167.392L412.428 168.016L444 177.976V177.292Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.18
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M444 178.084L416.594 176.632L412.14 168.364L411.552 168.676L416.185 177.268L444 178.744V178.084Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.68
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M412.14 169.132C411.36 168.892 410.927 168.052 411.18 167.272C411.42 166.492 412.26 166.06 413.04 166.312C413.821 166.552 414.253 167.392 414.001 168.172C413.761 168.952 412.92 169.384 412.14 169.132Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M413.184 167.884C412.8 167.164 411.9 166.9 411.18 167.284C410.459 167.668 410.195 168.568 410.579 169.288C410.963 170.008 411.864 170.272 412.584 169.888C413.304 169.504 413.568 168.604 413.184 167.884Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.37
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M413.22 167.764C412.524 168.196 411.612 167.98 411.192 167.284C410.771 166.588 410.975 165.676 411.672 165.256C412.368 164.824 413.28 165.04 413.701 165.736C414.133 166.432 413.917 167.344 413.22 167.764Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.29
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M409.15 166.792C409.583 167.488 410.495 167.704 411.179 167.272C411.876 166.84 412.092 165.928 411.659 165.244C411.227 164.548 410.315 164.332 409.631 164.764C408.934 165.196 408.718 166.108 409.15 166.792Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.62
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M334.182 0L334.795 12.0003L335.443 11.9643L334.843 0H334.182Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.62
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M347.808 0L335.935 12.1563L336.403 12.6123L348.72 0H347.808Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.26
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M336.595 11.8323C336.631 12.6483 336.007 13.3443 335.191 13.3803C334.374 13.4163 333.678 12.7923 333.642 11.9763C333.606 11.1603 334.23 10.4642 335.047 10.4282C335.863 10.3922 336.559 11.0163 336.595 11.8323Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.49
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M335.167 11.2922C334.59 11.8802 334.602 12.8162 335.191 13.3802C335.779 13.9563 336.715 13.9443 337.28 13.3562C337.856 12.7682 337.844 11.8322 337.255 11.2682C336.667 10.7042 335.731 10.7042 335.167 11.2922Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.31
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M385.706 0L394.673 20.5685L354.434 10.1282L366.475 0H365.454L353.042 10.4402L395.814 21.5405L386.426 0H385.706Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.68
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M393.377 20.1125C394.157 19.8605 394.985 20.2925 395.238 21.0605C395.49 21.8405 395.057 22.6686 394.289 22.9206C393.509 23.1726 392.681 22.7406 392.428 21.9725C392.176 21.1925 392.609 20.3645 393.377 20.1125Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.48
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M393.437 22.1162C394.229 22.3202 395.033 21.8522 395.237 21.0602C395.442 20.2682 394.973 19.4641 394.181 19.2601C393.389 19.0561 392.584 19.5242 392.38 20.3162C392.176 21.1082 392.645 21.9122 393.437 22.1162Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.13
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M365.454 0L354.062 9.57622L354.086 0H353.426L353.414 10.9923L366.475 0H365.454Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.49
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M355.551 8.16016L334.363 40.0689L333.822 39.7089L351.925 12.4203L330.065 32.7727L333.054 39.6369L332.454 39.9009L329.285 32.6167L355.551 8.16016Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.52
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M334.086 39.1089C334.411 39.8529 334.074 40.7289 333.318 41.0529C332.574 41.3769 331.698 41.0409 331.373 40.2849C331.049 39.5409 331.385 38.6649 332.142 38.3409C332.886 38.0169 333.762 38.3529 334.086 39.1089Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.48
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M332.898 39.001C332.442 39.685 332.634 40.597 333.318 41.053C334.002 41.509 334.915 41.317 335.371 40.633C335.827 39.949 335.635 39.037 334.951 38.5809C334.266 38.1249 333.354 38.3169 332.898 39.001Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.22
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M354.758 9.78027L330.929 31.9808L330.473 31.5008L352.717 10.7883L335.443 13.6804L330.377 31.4408L329.741 31.2488L334.927 13.0924L335.143 13.0684L354.758 9.78027Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.24
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M331.506 31.6809C331.277 32.4609 330.461 32.9169 329.681 32.7009C328.901 32.4729 328.444 31.6569 328.66 30.8769C328.889 30.0968 329.705 29.6408 330.485 29.8568C331.265 30.0848 331.722 30.9009 331.506 31.6809Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.29
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M329.753 30.6007C329.153 31.1527 329.117 32.0887 329.681 32.6887C330.233 33.2887 331.169 33.3247 331.77 32.7607C332.37 32.2087 332.406 31.2727 331.842 30.6727C331.277 30.0727 330.353 30.0367 329.753 30.6007Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.55
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M353.426 0L353.414 10.0082L336.127 12.9003L348.72 0H347.796L334.255 13.8723L354.062 10.5602L354.086 0H353.426Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.49
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M393.293 124.587L393.305 125.475L393.497 158.788L392.837 158.8L392.645 126.375L359.776 165.664L391.732 160.12L391.84 160.756L358.132 166.624L393.293 124.587Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.11
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M394.65 158.716C394.65 159.532 394.001 160.192 393.185 160.204C392.369 160.204 391.708 159.556 391.696 158.74C391.684 157.923 392.345 157.251 393.161 157.251C393.977 157.251 394.65 157.899 394.65 158.716Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.65
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M391.972 161.908C392.776 161.764 393.317 161.008 393.172 160.204C393.028 159.4 392.272 158.86 391.468 159.004C390.664 159.148 390.123 159.904 390.267 160.708C390.411 161.512 391.168 162.052 391.972 161.908Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.09
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M394.109 124.623L360.1 165.28L359.608 164.86L391.828 126.339L343.33 147.448L358.288 164.86L357.795 165.292L342.261 147.196L342.658 147.016L394.109 124.623Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.65
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M361.037 165.964C360.509 166.588 359.584 166.672 358.948 166.144C358.312 165.616 358.24 164.692 358.768 164.056C359.296 163.432 360.22 163.348 360.857 163.876C361.481 164.404 361.565 165.328 361.037 165.952V165.964Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M356.871 165.988C357.399 166.612 358.336 166.684 358.96 166.144C359.584 165.616 359.656 164.68 359.116 164.056C358.588 163.432 357.651 163.36 357.027 163.9C356.403 164.428 356.331 165.364 356.871 165.988Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M411.936 7.14035L411.696 7.89636L411.732 8.70038L376.847 10.3084L400.171 3.46826L400.303 3.50426L411.936 7.14035ZM384.361 9.04839L411.06 7.81236L400.159 4.40428L384.349 9.03639L384.361 9.04839Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.68
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M411.516 6.20403C412.644 6.15603 413.604 7.03205 413.652 8.16008C413.7 9.2881 412.836 10.2481 411.696 10.2961C410.567 10.3441 409.607 9.46811 409.559 8.34008C409.511 7.21205 410.387 6.25203 411.516 6.20403Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.4
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M411.095 9.50392C412.176 9.83992 413.328 9.23991 413.664 8.15989C414.001 7.07986 413.4 5.92783 412.32 5.59183C411.239 5.25582 410.087 5.85583 409.751 6.93586C409.415 8.01588 410.015 9.16791 411.095 9.50392Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.35
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M444 77.318L438.754 72.0258L444 65.9897V64.5977L437.505 72.0738L444 78.614V77.318Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.64
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M444 64.5973L438.286 71.1855L414.493 9.04801L444 22.8723V21.8643L412.836 7.27197L437.71 72.2175L437.974 72.9135L444 65.9893V64.5973Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M413.737 7.08008L414.085 7.9921L437.854 70.0695L437.013 70.3936L413.58 9.22813L380.688 68.2815L436.209 71.4856L436.161 72.3856L379.188 69.0975L413.737 7.08008Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.6
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M435.969 73.9818C437.097 74.0418 438.07 73.1898 438.13 72.0498C438.19 70.9217 437.337 69.9497 436.197 69.8897C435.069 69.8297 434.096 70.6817 434.036 71.8217C433.976 72.9618 434.828 73.9218 435.969 73.9818Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M411.696 7.78809L411.744 8.70011L381.048 10.1161L380.412 66.9015L412.32 9.63613L413.112 10.0801L379.464 70.4776L380.16 9.24012L380.58 9.22812L411.696 7.78809Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.16
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M411.516 6.20403C412.644 6.15603 413.604 7.03205 413.652 8.16008C413.7 9.2881 412.836 10.2481 411.696 10.2961C410.567 10.3441 409.607 9.46811 409.559 8.34008C409.511 7.21205 410.387 6.25203 411.516 6.20403Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.57
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M414.457 10.9441C415.009 9.96012 414.649 8.71209 413.664 8.16008C412.68 7.60807 411.432 7.96808 410.879 8.9521C410.327 9.93612 410.687 11.1842 411.672 11.7362C412.656 12.2882 413.905 11.9282 414.457 10.9441Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.48
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M224.677 16.9443L247.51 69.2776L237.63 66.1935L237.894 65.3295L245.889 67.8135L225.925 22.0925L235.889 63.1814L235.001 63.3974L223.813 17.2323L224.677 16.9443Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M237.414 62.7017C237.678 63.8057 237.006 64.9098 235.901 65.1738C234.797 65.4378 233.692 64.7658 233.428 63.6617C233.164 62.5577 233.837 61.4537 234.941 61.1897C236.045 60.9257 237.15 61.5977 237.414 62.7017Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.32
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M238.47 63.8296C237.39 63.4936 236.237 64.0936 235.901 65.1737C235.565 66.2537 236.165 67.4057 237.246 67.7417C238.326 68.0777 239.479 67.4777 239.815 66.3977C240.151 65.3177 239.551 64.1656 238.47 63.8296Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M439.102 71.654L385.478 130.947L384.806 130.335L437.157 72.4461L380.424 69.17L384.169 130.107L383.257 130.167L379.452 68.21L379.968 68.234L439.102 71.654Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.7
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M386.726 131.943C385.97 132.783 384.673 132.843 383.833 132.087C382.993 131.331 382.933 130.035 383.689 129.195C384.445 128.355 385.742 128.295 386.582 129.051C387.422 129.807 387.482 131.103 386.726 131.943Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.09
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M381.66 130.167C381.732 131.295 382.705 132.159 383.833 132.087C384.962 132.015 385.826 131.043 385.754 129.915C385.682 128.787 384.71 127.923 383.581 127.995C382.453 128.067 381.588 129.039 381.66 130.167Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.4
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M367.159 0L380.052 9.82823L345.755 91.7781L332.742 0H331.83L345.323 95.1742L381.024 9.85223L381.156 9.52822L368.66 0H367.159Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.29
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M331.83 0L344.999 92.8702L247.498 68.2816L303.571 0H302.394L245.889 68.8096L346.079 94.0822L332.742 0H331.83Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.11
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M346.847 93.0743L283.643 140.043L260.967 92.5822L261.783 92.1862L283.991 138.663L344.23 93.8903L262.467 91.1542L262.491 90.2422L346.847 93.0743Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.39
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M262.515 92.7504C261.387 92.7144 260.499 91.7664 260.535 90.6383C260.571 89.5103 261.519 88.6223 262.647 88.6583C263.776 88.6943 264.664 89.6423 264.628 90.7703C264.592 91.8984 263.644 92.7864 262.515 92.7504Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.16
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M263.26 91.5979C262.767 90.5779 261.543 90.1459 260.523 90.6379C259.502 91.1299 259.07 92.3539 259.562 93.374C260.054 94.394 261.279 94.826 262.299 94.334C263.32 93.842 263.752 92.618 263.26 91.5979Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.36
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M349.752 94.0823L262.467 91.1542L262.491 90.2422L341.325 92.8823L247.678 69.2657L259.886 88.7422L259.118 89.2222L245.709 67.8257L349.752 94.0823Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.53
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M262.515 92.7504C261.387 92.7144 260.499 91.7664 260.535 90.6383C260.571 89.5103 261.519 88.6223 262.647 88.6583C263.776 88.6943 264.664 89.6423 264.628 90.7703C264.592 91.8984 263.644 92.7864 262.515 92.7504Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.34
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M257.701 89.9782C258.302 90.9383 259.562 91.2263 260.523 90.6262C261.483 90.0262 261.771 88.7662 261.171 87.8062C260.571 86.8462 259.31 86.5582 258.35 87.1582C257.389 87.7582 257.101 89.0182 257.701 89.9782Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M136.576 0L154.162 26.8926L154.931 26.3886L137.656 0H136.576Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M188.387 0L156.803 26.6646L157.392 27.3606L189.792 0H188.387Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.65
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M158.496 28.5127C157.632 29.2447 156.335 29.1367 155.603 28.2727C154.871 27.4087 154.979 26.1126 155.843 25.3806C156.707 24.6486 158.004 24.7566 158.736 25.6206C159.468 26.4847 159.36 27.7807 158.496 28.5127Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.13
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M152.77 27.6728C153.394 28.6208 154.655 28.8848 155.603 28.2608C156.551 27.6368 156.815 26.3768 156.191 25.4288C155.567 24.4807 154.306 24.2167 153.358 24.8407C152.41 25.4648 152.146 26.7248 152.77 27.6728Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.26
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M128.881 0L135.675 20.6645L136.54 20.3885L129.841 0H128.881Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.26
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M136.576 0L154.534 27.4566L138.712 22.5245L138.448 23.3885L156.683 29.0767L137.656 0H136.576Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.6
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M138.028 19.7887C138.376 20.8688 137.8 22.0208 136.72 22.3808C135.639 22.7408 134.487 22.1528 134.127 21.0728C133.779 19.9927 134.355 18.8407 135.435 18.4807C136.516 18.1327 137.668 18.7087 138.028 19.7887Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.67
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M139.289 21.0244C138.208 20.6884 137.056 21.2884 136.72 22.3685C136.384 23.4485 136.984 24.6005 138.064 24.9365C139.145 25.2725 140.297 24.6725 140.633 23.5925C140.969 22.5125 140.369 21.3605 139.289 21.0244Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.34
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8748 0L22.0763 14.7483L22.9407 14.4963L18.8111 0H17.8748Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.34
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8719 0L24.2372 14.8923L24.8254 15.5884L43.2764 0H41.8719Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.46
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4532 13.9683C24.7653 15.0603 24.1291 16.1884 23.0487 16.5004C21.9563 16.8124 20.8278 16.1764 20.5157 15.0963C20.2036 14.0043 20.8399 12.8763 21.9203 12.5643C23.0007 12.2523 24.1411 12.8883 24.4532 13.9683Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.2
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2889 13.6087C22.4245 14.3407 22.3165 15.6367 23.0488 16.5007C23.7811 17.3647 25.0775 17.4727 25.9419 16.7407C26.8062 16.0087 26.9142 14.7127 26.182 13.8487C25.4497 12.9846 24.1532 12.8766 23.2889 13.6087Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.02
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8748 0L22.2324 15.3364L1.52458 0H0L23.841 17.6524L18.8111 0H17.8748Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M213.717 0L214.653 8.05219L157.716 27.0846L189.792 0H188.387L156.803 26.6646L157.344 27.3006L157.596 28.0807L215.638 8.6762L214.629 0H213.717Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.28
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M158.208 29.5685C157.139 29.9285 155.975 29.3525 155.615 28.2724C155.255 27.2044 155.831 26.0404 156.911 25.6804C157.992 25.3204 159.144 25.8964 159.504 26.9764C159.865 28.0444 159.288 29.2085 158.208 29.5685Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.68
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M155.855 25.3806C154.991 26.1126 154.883 27.4087 155.615 28.2727C156.347 29.1367 157.644 29.2447 158.508 28.5127C159.372 27.7807 159.48 26.4847 158.748 25.6206C158.016 24.7566 156.719 24.6486 155.855 25.3806Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M102.411 0L92.687 12.4803L93.4073 13.0323L103.551 0H102.411Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M111.69 0L106.72 12.6723L93.7675 13.6803L93.8275 14.5923L107.357 13.5363L112.663 0H111.69Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.14
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7278 13.9326C94.0316 14.8206 92.7471 14.9886 91.8467 14.2926C90.9584 13.5966 90.7904 12.3125 91.4866 11.4125C92.1829 10.5245 93.4674 10.3565 94.3677 11.0525C95.256 11.7485 95.4241 13.0325 94.7278 13.9326Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.63
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7434 12.0844C92.615 12.1684 91.7747 13.1524 91.8587 14.2925C91.9427 15.4205 92.9271 16.2605 94.0675 16.1765C95.196 16.0925 96.0363 15.0965 95.9522 13.9684C95.8682 12.8404 94.8718 12.0004 93.7554 12.0844H93.7434Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.06
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M102.411 0L92.7471 12.3963L95.5562 0H94.6319L91.8468 12.2883L92.7111 12.4923L93.4074 13.0323L103.551 0H102.411Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.63
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7278 13.9326C94.0316 14.8206 92.7471 14.9886 91.8467 14.2926C90.9584 13.5966 90.7904 12.3125 91.4866 11.4125C92.1829 10.5245 93.4674 10.3565 94.3677 11.0525C95.256 11.7485 95.4241 13.0325 94.7278 13.9326Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.24
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3102 11.832C90.0581 12.9361 90.7543 14.0281 91.8587 14.2801C92.9632 14.5321 94.0556 13.8361 94.3077 12.7321C94.5598 11.628 93.8635 10.536 92.7591 10.284C91.6547 10.032 90.5622 10.728 90.3102 11.832Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.13
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3332 15.9964L43.2764 0H41.8718L21.7522 16.9924L89.926 14.8083L89.89 13.8963L24.3332 15.9964Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.13
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6319 0L91.8468 12.2883L92.7231 12.4923L95.5562 0H94.6319Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.44
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3077 12.7443C94.0556 13.8483 92.9632 14.5443 91.8587 14.2923C90.7543 14.0403 90.0581 12.9483 90.3102 11.8443C90.5622 10.7402 91.6547 10.0442 92.7591 10.2962C93.8635 10.5482 94.5598 11.6402 94.3077 12.7443Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.17
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8659 16.4047C90.9944 16.3687 91.8827 15.4207 91.8467 14.2926C91.8107 13.1646 90.8623 12.2766 89.7339 12.3126C88.6055 12.3486 87.7171 13.2966 87.7531 14.4246C87.7891 15.5527 88.7375 16.4407 89.8659 16.4047Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.43
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M120.178 0H119.265L118.197 14.0523L134.763 21.9485L135.159 21.1205L119.145 13.5003L120.178 0Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.43
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M128.881 0L135.675 20.6645L136.54 20.3885L129.841 0H128.881Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.47
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M138.028 19.7887C138.376 20.8688 137.8 22.0208 136.72 22.3808C135.639 22.7408 134.487 22.1528 134.127 21.0728C133.779 19.9927 134.355 18.8407 135.435 18.4807C136.516 18.1327 137.668 18.7087 138.028 19.7887Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.05
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M133.983 23.3403C135.003 23.8323 136.228 23.3883 136.72 22.3683C137.212 21.3482 136.768 20.1242 135.747 19.6322C134.727 19.1402 133.503 19.5842 133.01 20.6042C132.518 21.6243 132.962 22.8483 133.983 23.3403Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.06
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M119.265 0L118.365 11.7963L119.277 11.8683L120.177 0H119.265Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.06
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M112.663 0H111.69L106.384 13.5243L116.708 14.1243L116.756 13.2123L107.681 12.6843L112.663 0Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.39
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M120.874 11.8923C120.79 13.0203 119.805 13.8603 118.677 13.7763C117.548 13.6923 116.708 12.7083 116.792 11.5803C116.876 10.4522 117.861 9.61222 118.989 9.69622C120.117 9.78022 120.958 10.7642 120.874 11.8923Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.69
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M116.504 15.7084C117.633 15.7684 118.605 14.9163 118.665 13.7763C118.725 12.6363 117.873 11.6763 116.732 11.6163C115.604 11.5563 114.631 12.4083 114.571 13.5483C114.511 14.6883 115.364 15.6484 116.504 15.7084Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.43
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M444 132.975L441.719 131.415L444 136.179V132.975Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.23
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M345.263 93.1221L345.863 93.7941L294.604 147.027L293.955 146.403L341.409 97.1182L284.52 139.395L291.843 146.439L291.206 147.099L283.115 139.311L283.547 138.987L345.263 93.1221Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.32
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M295.828 148.059C295.048 148.875 293.751 148.899 292.935 148.119C292.119 147.339 292.094 146.043 292.875 145.227C293.655 144.411 294.964 144.387 295.768 145.167C296.584 145.947 296.608 147.255 295.828 148.059Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.11
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M290.03 148.179C290.846 148.959 292.142 148.935 292.923 148.119C293.703 147.303 293.679 146.007 292.863 145.227C292.046 144.447 290.75 144.471 289.97 145.287C289.189 146.103 289.213 147.399 290.03 148.179Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.24
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M246.561 67.4653L259.886 88.7418L259.118 89.2218L246.837 69.6254L243.032 81.7937L258.974 89.3898L258.578 90.2059L241.927 82.2737L246.561 67.4653Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M261.183 87.8062C261.783 88.7662 261.495 90.0262 260.535 90.6262C259.574 91.2263 258.314 90.9383 257.713 89.9782C257.113 89.0182 257.401 87.7582 258.362 87.1582C259.322 86.5582 260.583 86.8462 261.183 87.8062Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M257.798 91.5981C258.818 92.0901 260.042 91.6461 260.535 90.6261C261.027 89.6061 260.583 88.382 259.562 87.89C258.542 87.398 257.317 87.842 256.825 88.862C256.333 89.8821 256.777 91.1061 257.798 91.5981Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.12
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M247.27 68.2459L243.5 80.3182L242.636 80.0422L246.129 68.8459L236.67 65.8939L242.204 80.0542L241.351 80.3902L235.133 64.4658L247.27 68.2459Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.58
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M245.049 80.6902C244.713 81.7702 243.56 82.3702 242.48 82.0342C241.399 81.6982 240.799 80.5462 241.135 79.4661C241.471 78.3861 242.624 77.7861 243.704 78.1221C244.785 78.4581 245.385 79.6101 245.049 80.6902Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.32
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M239.827 80.8698C240.235 81.9258 241.423 82.4418 242.48 82.0338C243.536 81.6258 244.052 80.4377 243.644 79.3817C243.236 78.3257 242.047 77.8097 240.991 78.2177C239.935 78.6257 239.418 79.8137 239.827 80.8698Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.48
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M302.394 0L248.326 65.8575L275.996 0H275L245.073 71.2457L303.571 0H302.394Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.28
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M275.012 0L247.029 66.5776L247.87 66.9256L275.996 0H275.012Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.28
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M245.049 0H243.644L223.957 16.7764L223.705 17.0044L245.505 66.9496L246.333 66.5776L224.809 17.2564L245.049 0Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M247.762 65.8454C248.218 66.8774 247.738 68.0894 246.705 68.5454C245.673 69.0014 244.46 68.5214 244.004 67.4894C243.548 66.4574 244.028 65.2453 245.061 64.7893C246.093 64.3333 247.305 64.8133 247.762 65.8454Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.57
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M245.601 65.8693C245.157 66.9133 245.649 68.1134 246.693 68.5574C247.738 69.0014 248.938 68.5094 249.382 67.4653C249.815 66.4213 249.334 65.2213 248.29 64.7773C247.246 64.3333 246.045 64.8253 245.601 65.8693Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.23
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M412.572 0L413.16 7.52418L400.712 3.63609L401.588 0H400.652L399.727 3.84009L399.631 4.2481L414.169 8.78421L413.484 0H412.572Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.15
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M400.652 0L399.787 3.57608L381.624 8.90421L387.206 0H386.138L379.584 10.4522L400.291 4.3801L400.544 4.3081L401.588 0H400.652Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.43
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M386.138 0L380.484 9.01221L368.66 0H367.159L380.328 10.0442L380.724 10.3442L387.207 0H386.138Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.65
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M444 168.856L404.001 147.003L442.632 133.311L444 136.179V134.067L443.1 132.183L401.78 146.823L444 169.888V168.856Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M236.201 64.6934L242.204 80.0537L241.351 80.3897L235.601 65.6654L216.034 67.6694L240.967 80.7377L240.547 81.5417L212.937 67.0814L236.201 64.6934Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.28
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M243.644 79.3817C244.052 80.4377 243.536 81.6258 242.48 82.0338C241.423 82.4418 240.235 81.9258 239.827 80.8698C239.418 79.8137 239.935 78.6257 240.991 78.2177C242.047 77.8097 243.236 78.3257 243.644 79.3817Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.07
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M239.719 82.898C240.727 83.426 241.964 83.042 242.48 82.034C243.008 81.0259 242.624 79.7899 241.615 79.2739C240.607 78.7459 239.371 79.1299 238.854 80.1379C238.326 81.1459 238.722 82.382 239.719 82.898Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M224.209 15.0005L236.465 65.5817L216.466 67.6217L216.37 66.7217L235.337 64.7776L224.305 19.2606L215.301 65.5457L214.413 65.3777L224.209 15.0005Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.6
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M216.73 69.2056C215.601 69.3256 214.593 68.4976 214.485 67.3816C214.365 66.2536 215.193 65.2455 216.31 65.1375C217.438 65.0175 218.447 65.8456 218.555 66.9616C218.675 68.0896 217.846 69.0976 216.73 69.2056Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.48
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M214.701 7.30811L224.749 16.9683L224.701 17.2083L215.301 65.5455L214.677 65.4255H214.053L214.701 7.30811ZM223.765 17.2803L215.59 9.42015L215.001 62.3774L223.765 17.2923V17.2803Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.1
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M216.886 65.7494C216.67 66.8654 215.589 67.5854 214.485 67.3694C213.369 67.1534 212.648 66.0734 212.864 64.9693C213.081 63.8533 214.161 63.1333 215.265 63.3493C216.37 63.5653 217.102 64.6453 216.886 65.7494Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.22
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M212.456 65.3055C212.444 66.4335 213.357 67.3696 214.485 67.3816C215.613 67.3936 216.55 66.4815 216.562 65.3535C216.574 64.2255 215.661 63.2895 214.533 63.2775C213.405 63.2655 212.468 64.1775 212.456 65.3055Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.04
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M215.602 7.72852L214.953 65.4379L214.053 65.4259L214.689 9.00055L156.635 28.405L213.117 65.9179L212.612 66.6739L154.583 28.141L215.602 7.72852Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.24
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M216.55 65.3535C216.538 66.4815 215.614 67.3936 214.473 67.3816C213.345 67.3696 212.432 66.4455 212.444 65.3055C212.456 64.1775 213.381 63.2655 214.521 63.2775C215.65 63.2895 216.562 64.2135 216.55 65.3535Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.08
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M211.64 67.9457C212.589 68.5697 213.861 68.3177 214.485 67.3697C215.109 66.4216 214.857 65.1496 213.909 64.5256C212.961 63.9016 211.7 64.1536 211.064 65.1016C210.44 66.0496 210.692 67.3216 211.64 67.9457Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.54
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M362.753 81.8901L384.458 132.375L366.271 137.703L366.007 136.839L383.209 131.787L363.75 86.5102L364.686 135.867L363.774 135.879L362.753 81.8901Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.69
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M366.283 135.735C366.307 136.863 365.406 137.799 364.278 137.823C363.149 137.847 362.213 136.947 362.189 135.819C362.165 134.691 363.065 133.755 364.194 133.731C365.322 133.707 366.259 134.607 366.283 135.735Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.21
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M365.658 135.279C364.578 135.603 363.954 136.731 364.266 137.823C364.59 138.903 365.718 139.527 366.811 139.215C367.891 138.891 368.515 137.763 368.203 136.671C367.891 135.579 366.751 134.967 365.658 135.279Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.19
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M380.34 67.7056L384.169 130.119L383.389 130.167L382.657 130.479L362.717 84.098L362.957 83.8819L380.352 67.7176L380.34 67.7056ZM383.221 129.507L379.548 69.6736L363.798 84.314L383.221 129.495V129.507Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.64
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M385.754 129.915C385.826 131.043 384.962 132.015 383.833 132.087C382.705 132.159 381.732 131.295 381.66 130.167C381.588 129.039 382.453 128.067 383.581 127.995C384.71 127.923 385.682 128.787 385.754 129.915Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.02
  }, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M381.144 131.007C381.588 132.051 382.801 132.531 383.833 132.075C384.878 131.631 385.358 130.419 384.902 129.387C384.457 128.343 383.245 127.863 382.213 128.319C381.168 128.763 380.688 129.975 381.144 131.007Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.64
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M363.69 83.4619L364.686 135.867H363.858L363.089 136.203L344.95 93.2781L363.678 83.4619H363.69ZM363.774 135.471L362.813 84.9499L346.127 93.6861L363.774 135.471Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.26
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M362.177 135.807C362.201 136.935 363.137 137.835 364.266 137.811C365.394 137.787 366.295 136.851 366.271 135.723C366.247 134.595 365.31 133.695 364.182 133.719C363.053 133.743 362.153 134.679 362.177 135.807Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M381.108 5.52002L380.424 66.7454L379.512 66.7334L380.1 13.8362L364.026 82.8618L378.203 69.6855L378.827 70.3455L362.465 85.5499L381.108 5.52002Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.37
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M379.836 71.5817C380.664 70.8136 380.712 69.5176 379.944 68.6896C379.175 67.8616 377.879 67.8136 377.051 68.5816C376.222 69.3496 376.174 70.6456 376.943 71.4737C377.711 72.3017 379.007 72.3497 379.836 71.5817Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.69
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M380.604 11.6765L363.642 84.5062L344.626 94.4664L345.119 93.3024L379.428 11.2925L379.992 11.5325L380.592 11.6765H380.604ZM362.849 83.8942L378.935 14.8446L346.451 92.4864L362.861 83.8942H362.849Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.42
  }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M377.927 10.7763C378.359 9.73223 379.56 9.24022 380.604 9.67223C381.648 10.1042 382.14 11.3043 381.708 12.3483C381.276 13.3923 380.076 13.8843 379.031 13.4523C377.987 13.0203 377.495 11.8203 377.927 10.7763Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.37
  }, _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M382.141 12.1441C382.393 11.0401 381.708 9.93606 380.604 9.68406C379.5 9.43205 378.395 10.1161 378.143 11.2201C377.891 12.3241 378.575 13.4281 379.68 13.6801C380.784 13.9322 381.888 13.2481 382.141 12.1441Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.6
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M438.49 70.7778L443.352 133.155L442.908 133.203L393.065 137.595L392.993 136.683L442.379 132.339L437.77 73.3219L392.597 135.999L391.852 135.459L438.49 70.7778Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.41
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M393.305 139.167C392.176 139.263 391.18 138.435 391.084 137.307C390.988 136.179 391.816 135.183 392.944 135.087C394.073 134.991 395.069 135.819 395.165 136.947C395.261 138.075 394.433 139.071 393.305 139.167Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.15
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M390.628 134.451C389.968 135.363 390.172 136.647 391.096 137.307C392.008 137.967 393.293 137.763 393.953 136.839C394.613 135.927 394.409 134.643 393.485 133.983C392.561 133.323 391.288 133.527 390.628 134.451Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.18
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M444 132.195L392.993 136.683L393.065 137.595L439.342 133.515L402.98 146.404L392.885 138.183L392.308 138.891L402.8 147.424L444 132.831V132.195Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.68
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M393.305 139.167C392.176 139.263 391.18 138.435 391.084 137.307C390.988 136.179 391.816 135.183 392.944 135.087C394.073 134.991 395.069 135.819 395.165 136.947C395.261 138.075 394.433 139.071 393.305 139.167Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M393.965 137.007C393.089 136.287 391.793 136.431 391.084 137.307C390.364 138.183 390.508 139.479 391.384 140.187C392.261 140.907 393.557 140.763 394.265 139.887C394.986 139.011 394.842 137.715 393.965 137.007Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.37
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M393.953 136.839C393.292 137.751 392.008 137.967 391.096 137.307C390.183 136.647 389.967 135.363 390.627 134.451C391.288 133.539 392.572 133.323 393.485 133.983C394.397 134.643 394.613 135.927 393.953 136.839Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.29
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M388.227 137.775C389.139 138.435 390.424 138.231 391.084 137.307C391.744 136.395 391.54 135.111 390.616 134.451C389.703 133.791 388.419 133.995 387.759 134.919C387.098 135.831 387.302 137.115 388.227 137.775Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.49
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M219.455 0H218.459L214.593 8.4722L222.54 16.1044L223.164 15.4564L215.698 8.25619L219.455 0Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.49
  }, _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M227.126 0L224.185 15.1324L225.073 15.3004L228.05 0H227.126Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.52
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M224.197 14.2325C225.013 15.0125 225.037 16.3086 224.257 17.1246C223.477 17.9406 222.168 17.9646 221.364 17.1846C220.547 16.4046 220.523 15.1085 221.304 14.2925C222.084 13.4765 223.393 13.4525 224.197 14.2325Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.48
  }, _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M222.636 14.7242C222.42 15.8402 223.14 16.9083 224.257 17.1243C225.373 17.3403 226.442 16.6203 226.658 15.5042C226.874 14.3882 226.154 13.3202 225.037 13.1042C223.921 12.8882 222.852 13.6082 222.636 14.7242Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.22
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M218.447 0L215.542 6.40815L216.37 6.78016L219.455 0H218.447Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.22
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M213.717 0L214.473 6.48015L215.373 6.38415L214.629 0H213.717Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.24
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M216.946 6.09596C217.078 7.22399 216.274 8.23201 215.145 8.36402C214.017 8.49602 213.009 7.692 212.876 6.56398C212.744 5.43595 213.549 4.42793 214.677 4.29592C215.806 4.16392 216.814 4.96794 216.946 6.09596Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.29
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M214.125 5.65215C213.657 6.68417 214.113 7.8962 215.145 8.36421C216.178 8.83222 217.39 8.37621 217.858 7.34419C218.327 6.31216 217.87 5.10014 216.838 4.63213C215.806 4.16411 214.593 4.62013 214.125 5.65215Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.49
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M345.479 92.1621L345.959 93.3021L363.93 135.855L363.089 136.203L345.599 94.8022L324.435 162.58L362.381 138.483L362.873 139.251L322.826 164.668L345.479 92.1621Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.11
  }, _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M365.358 135.135C365.802 136.179 365.31 137.379 364.266 137.823C363.221 138.267 362.021 137.775 361.577 136.731C361.133 135.687 361.625 134.487 362.669 134.043C363.714 133.599 364.914 134.091 365.358 135.135Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.65
  }, _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M363.642 140.643C364.602 140.031 364.878 138.771 364.278 137.811C363.666 136.851 362.405 136.575 361.445 137.175C360.484 137.787 360.208 139.047 360.809 140.007C361.421 140.967 362.681 141.243 363.642 140.643Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.09
  }, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M346.547 91.7783L324.639 161.908L323.774 161.632L344.53 95.1864L293.679 147.988L322.094 162.34L321.686 163.156L292.178 148.252L292.599 147.808L346.547 91.7783Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.65
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M326.199 162.28C325.863 163.36 324.711 163.96 323.63 163.624C322.55 163.288 321.95 162.136 322.286 161.055C322.622 159.975 323.774 159.375 324.855 159.711C325.935 160.047 326.535 161.199 326.199 162.28Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M320.869 164.524C321.878 165.04 323.114 164.632 323.618 163.624C324.123 162.616 323.726 161.38 322.718 160.876C321.71 160.36 320.473 160.768 319.969 161.776C319.453 162.784 319.861 164.02 320.869 164.524Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.24
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M416.69 0H415.729L413.112 8.4002L444 22.8725V21.8645L414.217 7.90818L416.69 0Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.37
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M415.729 0L413.929 5.77213L413.484 0H412.572L413.388 10.5362L416.69 0H415.729Z",
    fill: "#5CBF14"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProffesionalismNetImg);
export default __webpack_public_path__ + "static/media/proffesionalism-net-img.0e8cc679f262d0158ff0146c90387e02.svg";
export { ForwardRef as ReactComponent };